import React from 'react';
import { FadeIn } from './FadeIn';
import { Download } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-139">
      <FadeIn data-id="element-140">
        <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-6 tracking-tight" data-id="element-141">
          Una herramienta práctica que puedes aplicar desde hoy
        </h2>
        <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-142">
          Esto no es teoría ni consejos genéricos de entrevistas. Es una guía
          práctica diseñada para ayudarte a entrar a tu próxima entrevista con
          una estrategia clara, un posicionamiento fuerte y mejores preguntas.
        </p>

        <a href="https://guiadownload.com/products/como-destacar-en-una-entrevista-de-trabajo" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center gap-3 bg-emerald text-white px-10 py-5 rounded-xl font-bold text-xl hover:bg-emerald-hover transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 w-full sm:w-auto" data-id="element-143">
          <Download className="w-6 h-6" data-id="element-144" />
          Descargar la guía ahora
        </a>
      </FadeIn>
    </section>;
}